import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Paper, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { storesUrl } from "../../utils/urls";
import PageHeader from "../../components/page-layout/PageHeader";
import ServerPaginationDataGrid from "../../components/tables/ServerPaginationDataGrid";
import { Edit, Map, PunchClock, Settings, InfoOutlined, Receipt } from "@mui/icons-material";
import moment from "moment";
import { Switch } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-hot-toast";

const Stores = () => {
  const navigate = useNavigate();

  const columns = [
    { field: "name", headerName: "Store Name", flex: 1, minWidth: 180 },
    {
      field: "vendorName",
      headerName: "Vendor",
      flex: 1,
      minWidth: 180,
      renderCell: ({ row }) => {
        const name = row.vendor_data?.name;    // Access the nested property
        const phone = row.vendor_data?.phone;
        return name ? (
          <div>
            <div>{name}</div>
            <div style={{ fontSize: 12, color: "#777" }}>{phone}</div>
          </div>
        ) : (
          <span style={{ color: "#999" }}>-</span>
        );
      }


    },




    {
      field: "time",
      headerName: "Open & Close Time",
      width: 210,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <span style={{ fontWeight: 500, color: "#388e3c" }}>
            {moment(row.openTime, "HH:mm:ss").format("hh:mm A")}
          </span>
          <span style={{ color: "#888" }}>-</span>
          <span style={{ fontWeight: 500, color: "#d32f2f" }}>
            {moment(row.closeTime, "HH:mm:ss").format("hh:mm A")}
          </span>
        </Stack>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: ({ row }) => <StatusSwitch row={row} />,
    },
    {
      field: "Actions",
      headerName: "Store Actions",
      width: 800,
      sortable: false,
      renderCell: ({ row }) => (
        <Box display="flex" gap={2} alignItems={"center"} pt={1}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Map />}
            onClick={() => {
              if (row.latitude && row.longitude) {
                const url = `https://www.google.com/maps?q=${row.latitude},${row.longitude}`;
                window.open(url, "_blank");
              }
            }}
          >
            See Map
          </Button>
          <Button
            startIcon={<Edit />}
            size="small"
            variant="contained"
            onClick={() => navigate(`/store/edit/${row.id}`)}
          >
            Edit Store
          </Button>
          <Button
            startIcon={<Settings />}
            size="small"
            variant="outlined"
            onClick={() => {
              navigate(`/store/${row.id}/editService`, {
                state: { name: row.name },
              });
            }}
          >
            Edit Config
          </Button>
          <Button
            startIcon={<InfoOutlined />}
            size="small"
            variant="outlined"
            onClick={() => {
              navigate(`/store/${row.id}/editMeta`, {
                state: { name: row.name },
              });
            }}
          >
            Edit Meta
          </Button>
          <Button
            startIcon={<Receipt />}
            size="small"
            variant="outlined"
            onClick={() => navigate("/transactions")}
          >
            View Transactions
          </Button>
        </Box>
      ),
    },
  ];

  // Import Switch from MUI

  // Handler for status toggle
  const handleStatusToggle = (row) => {
    // Implement your status update logic here, e.g., API call
    // Example: updateStoreStatus(row.id, row.status === "Active" ? "Inactive" : "Active");
    // You may want to refetch data or optimistically update UI
    alert(`Toggle status for store: ${row.name}`);
  };

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Stores"
        lead="Manage all your stores, update their details, and configure their settings from this page."
        showBack
        buttonOnClick={() => navigate("/store/add")}
        buttonTitle="Add Store"
      />
      <ServerPaginationDataGrid
        name="stores-table"
        url={storesUrl}
        columns={columns}

      />
    </Stack>
  );
};

export default Stores;

const StatusSwitch = ({ row }) => {
  const [state, setState] = useState("ACTIVE");

  const handleStatusToggle = () => {
    const newStatus = state === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setState(newStatus);
    axiosInstance.patch(`${storesUrl}/${row.id}`, {
      status: newStatus,
    });
  };

  useEffect(() => {
    if (row.status !== state) setState(row.status);
  }, [row.status]);

  const handleSwitchChange = () => {
    // Show toast notification instead of confirm dialog
    // You can use your preferred toast library, e.g., notistack or MUI Snackbar
    // Example using notistack:
    // enqueueSnackbar(`Store will be ${state === "ACTIVE" ? "deactivated" : "activated"}.`, { variant: "info" });
    showEmailToast(handleStatusToggle, state === "ACTIVE");
  };

  return (
    <Switch
      checked={state === "ACTIVE"}
      color="success"
      size="small"
      onChange={handleSwitchChange}
    />
  );
};

const StatusToast = ({ toastId, callFn, flag }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", p: 1 }}>
      <Box sx={{ flex: 1 }}>
        <Box sx={{ fontWeight: "bold", mb: 0.5 }}>
          Want to {flag ? "In-Active" : "Active"}?
        </Box>
        <Box sx={{ color: "text.secondary", fontSize: 14 }}>
          You received a new email from somebody
        </Box>
      </Box>
      <Stack
        gap={1}
        sx={{
          width: "90px",
          ml: 1,
        }}
      >
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            // closeToast();
             toast.dismiss(toastId);
            callFn();
            
          }}
        >
          Sure
        </Button>
        <Button variant="outlined" size="small"
        //  onClick={closeToast}
         onClick={() => toast.dismiss(toastId)}
         >
          Cancel
        </Button>
      </Stack>
    </Box>
  );
};

// Call this function to show toast
// export const showEmailToast = (callFn, flag) => {
//   toast(<StatusToast callFn={callFn} flag={flag} />, {
//     closeButton: false,
//     autoClose: false,
//     className: "status-toast",
//   });
// };
export const showEmailToast = (callFn, flag) => {
  const toastId = toast.custom(
    (t) => <StatusToast callFn={callFn} flag={flag} toastId={t.id} />,
    {
      duration: Infinity,
      position: "top-center",
    }
  );
};

